import { render, staticRenderFns } from "./LawCounterPartyAttorneyForm.vue?vue&type=template&id=355d61ea&"
import script from "./LawCounterPartyAttorneyForm.vue?vue&type=script&lang=js&"
export * from "./LawCounterPartyAttorneyForm.vue?vue&type=script&lang=js&"
import style0 from "./LawCounterPartyAttorneyForm.vue?vue&type=style&index=0&id=355d61ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports